import React, { FunctionComponent, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { TestID } from '../../../utils/PropTypesDefinitions'
import SmallBodyFont from '../../../Theme/Fonts/SmallBody'

export type SquadInfoItemProps = {
    /**
     * description on the left
     * */
    label: string
    /**
     * actual value on the right
     * */
    value: string
} & TestID

const SquadInfoItem: FunctionComponent<SquadInfoItemProps> = ({
    label,
    value,
    testID,
}): ReactElement => {
    return (
        <Grid
            noExpand
            horizontal
            centerVertical
            height={50}
            paddingX={5}
            backgroundColor="pearl"
            borderBottom={1}
            borderColor="tahitian-4"
            testID={testID}
        >
            <Grid minWidth={0} paddingRight={5}>
                <SmallBodyFont numberOfLines={1} color="onyx">
                    {label}
                </SmallBodyFont>
            </Grid>
            <SmallBodyFont numberOfLines={1} color="keshi-3">
                {value}
            </SmallBodyFont>
        </Grid>
    )
}

export default SquadInfoItem
